import { useState, useCallback } from "react";

/**
 * Cycles a value through a fixed set of states on each call.
 * Used by the design's tri-state filter chips (e.g. `[null, "asc", "desc"]`).
 */
export function useToggleState<T>(states: readonly T[], initial?: T): [T, () => void, (v: T) => void] {
  const [value, setValue] = useState<T>(initial ?? states[0]);
  const cycle = useCallback(() => {
    setValue((cur) => {
      const i = states.indexOf(cur);
      return states[(i + 1) % states.length];
    });
  }, [states]);
  return [value, cycle, setValue];
}
